 /**
  * File: attendExam.js
  * Project: educore
  * Created Date: 2019--01-23
  * Author: Raziya S
  * Screen : 
  */
 import imageViewTemplate from '../../views/activity/imageViewPopup.html'
 class AttendExam {
     // @ngInject
     constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $timeout, uploadService, CQuesConst) {
         //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
         let self = this;
         let authoring = localStorageService.get("authoringData")
         $scope.scope = $scope.$parent

         if (authoring === undefined)
             $state.go('dashboard')
         $scope.score = 0
         let qpId = $stateParams.qpId
         $scope.minutes = []
         for (var min = 5; min <= 20; min += 5) {
             $scope.minutes.push(min);
         }
         $scope.class = authoring.class
         let userId = localStorageService.get('user_id')
         let schoolId = authoring.school_id
         let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
         let USER_PATH = userId + "/question/"
         let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
         let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT

         $scope.questionsSet = $scope.$parent.questions
         $scope.$timeout = $timeout;
         // $scope.serverUrl = CONSTANTS.FILE_UPLOAD_URL + "/server-uploads"
         // $scope.userPath = userId + "/drawing/"
         $scope.beautifyFIB = function(question) {
             return question.replace(/_/g, " (_______) ")
         }
         $scope.sortableOptions = {
             containment: '#sortable-container'
         };

         $rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {
             //console.log(fromState.name)
             if (fromState.name === "studentQuestionPaperPreview") {
                 $mdDialog.canel()
             }
         })

         this.$postLink = function() {
             if ($scope.$parent.indexToShow === 0) {
                 $mdDialog.cancel()
             }
         };
         $scope.$on('showQuestion', function() {
             $scope.scope = $scope.$parent

             console.log("&&&&&&&&&&&&&")
             console.log($scope.scope.indexToShow)
             console.log("&&&&&&&&&&&&&")

         })

         $scope.dragControlListeners = {
             accept: function(sourceItemHandleScope, destSortableScope) {
                 return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
             },
             itemMoved: function(event) {
                 event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
             },
             orderChanged: function(event) {},
             dragStart: function() {

             },
             dragEnd: function() {
                 $scope.$parent.$parent.isOptionSelected = true;
             },
             containment: '#board', //optional param.
             clone: false, //optional param for clone feature.
             allowDuplicates: false //optional param allows duplicates to be dropped.
         };

         function moveObjWithinArray(arr, old_index, new_index) {
             if (new_index >= arr.length) {
                 var k = new_index - arr.length + 1;
                 while (k--) {
                     arr.push(undefined);
                 }
             }
             arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
             return arr; // for testing
         };
         $scope.changeValue = function(index, question, answers, key, event) {
             $scope.$parent.$parent.isOptionSelected = true;
             // event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
         }
         $scope.removeAnswerImg = function(index) {
                 $scope.$parent.imageData[$scope.$parent.indexToShow].splice(index, 1)
             }
             //Image upload for question
         $scope.answerImgUpload = function(file, opt) {
             let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
             _.each(file, function(fileObj) {
                 let extValue = fileObj.name.split('.').pop().toLowerCase();
                 if (_.contains(supportedFrmts, extValue)) {
                     uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function(result) {
                         if (result.url) {
                             if (!_.isArray($scope.$parent.imageData[$scope.$parent.indexToShow]))
                                 $scope.$parent.imageData[$scope.$parent.indexToShow] = []
                             $scope.$parent.imageData[$scope.$parent.indexToShow].push(result.url)
                         }
                     })
                 } else {
                     toastr.error("Please select the supported format jpg, jpeg, png")
                     fileObj = {}
                 }
             })
         }
          //Open dialog to view image
         $scope.showImage = (url) => {
                 let imageObj = {
                     image: url
                 }
                 var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                 $mdDialog.show({
                     locals: {
                         imageDetails: imageObj
                     },
                     template: imageViewTemplate,
                     controller: ['$scope', '$mdDialog', 'imageDetails', imageDialogCtrl],
                     parent: angular.element(document.body),
                     clickOutsideToClose: true,
                     fullscreen: useFullScreen
                 })
             }
             //DIALOG CONTROLLER FOR IMAGE
         var imageDialogCtrl = function($scope, $mdDialog, imageDetails) {
             $scope.fileUrl = PREVIEW_URL
             $scope.imageDetails = imageDetails
             $scope.cancel = function() {
                 $mdDialog.cancel()
             }
         }


         let MQ = MathQuill.getInterface(2);
         $timeout(function() {
             var questionElements = document.getElementsByClassName('question_desc')
             _.each(questionElements, function(spanElement) {
                 MQ.StaticMath(spanElement);
             })
         }, 1000);

         $scope.formatToLatex = function(type, index, ansType, ansIndex) {
             var answerElements = document.getElementsByClassName('answer-field')
             _.each(answerElements, function(spanElement) {
                 spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
                 var mathField = MQ.MathField(spanElement, {
                     spaceBehavesLikeTab: false,
                     restrictMismatchedBrackets: true,
                     handlers: {
                         edit: function() {
                             if (type === 'SA') {
                                 $scope.$parent.ansSa[$scope.$parent.indexToShow] = mathField.latex()
                             } else if (type === 'LA') {
                                 $scope.$parent.ansLa[$scope.$parent.indexToShow] = mathField.latex()
                             } else if (type === 'OWQ') {
                                 if (!$scope.$parent.ansOwq[$scope.$parent.indexToShow]) {
                                     $scope.$parent.ansOwq[$scope.$parent.indexToShow] = {
                                         choice: []
                                     }
                                 }
                                 $scope.$parent.ansOwq[$scope.$parent.indexToShow] = mathField.latex()
                                 $scope.$parent.$parent.setSelectedAns('enteredAns', 'OWQ')
                             } else if (type === 'FIB' || type == 'IBT_FIB') {
                                 if (!$scope.$parent.ansFib[$scope.$parent.indexToShow]) {
                                     $scope.$parent.ansFib[$scope.$parent.indexToShow] = {
                                         choice: []
                                     }
                                 }
                                 $scope.$parent.ansFib[$scope.$parent.indexToShow].choice[index] = mathField.latex()
                                 $scope.$parent.$parent.setSelectedAns('enteredAns', 'FIB')
                             } else if (type === 'ASLLISTEN') {
                                 if (ansType === 'fib') {
                                     $scope.$parent.ansAslListen[$scope.$parent.indexToShow].ans[index].answer[ansIndex] = mathField.latex()
                                 } else if (ansType == 'text') {
                                     $scope.$parent.ansAslListen[$scope.$parent.indexToShow].ans[index].answer = mathField.latex()
                                 }
                             }
                         }
                     }
                 });
             })
         }

         /*
          * Function to save recorded file url
          *
          * @url : uploaded file url
          *
          * @return : null
          */
         $scope.saveRecordedUrl = (url, index) => {
             if (index >= 0) {
                 $scope.$parent.ansAslListen[$scope.$parent.indexToShow].ans[index].answer = url
             } else {
                 $scope.$parent.ansAslSpeak[$scope.$parent.indexToShow].answer = url
             }
         }


         $scope.setFilePath = function(img) {
             let new_url = img ? PREVIEW_URL + img : undefined
             return new_url
         }
         $scope.beautifyFIB = function(question) {
             return question.replace(/_/g, " _______ ")
         }

         //for question -drawing
         /*####################################################################################*/
         $timeout(function() {


             let canvasList = document.getElementsByClassName('canvas');

             _.each(canvasList, function(canvas) {

                 if (canvas) {
                     var ctx = canvas.getContext('2d');
                 }


                 $scope.backingScale = function() {
                     //var ctx = canvas.getContext('2d');
                     var dpr = window.devicePixelRatio || 1;
                     /*var bsr = ctx.webkitBackingStorePixelRatio ||
                         ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio ||
                         ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;*/

                     /* return dpr / bsr;*/
                 };
                 $scope.normalHeight = $window.innerHeight
                 var ratio = $scope.backingScale()
                 var w = 600
                 var h = 400

                 $scope.windowWidth = Math.floor(w * ratio);
                 $scope.windowHeight = Math.floor(h * ratio);
                 $scope.windowInnerWidth = Math.floor(w) + 'px';
                 $scope.windowInnerHeight = Math.floor(h) + 'px';
                 ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
                 //scope.resetDrawing()
                 //ctx.scale(scope.scale,scope.scale);
                 //scope.resetDrawing()
                 canvas.style.pointerEvents = 'auto|none';

                 let drawing = false;
                 let lastX;
                 let lastY;
                 ctx.lineJoin = ctx.lineCap = 'round';
                 let points = [],
                     fhPoints = [];
                 let rect;

                 $scope.setTool = function(tool) {
                     $scope.toolName = tool;
                 };
                 $scope.getPdfHeight = function() {
                     // pdfHolder = element.find('pdfviewer')[0];

                     var ratio = $scope.backingScale()
                     var w = 600
                     var h = 400
                     $scope.windowWidth = Math.floor(w * ratio);
                     $scope.windowHeight = Math.floor(h * ratio);
                     $scope.windowInnerWidth = Math.floor(w) + 'px';
                     $scope.windowInnerHeight = Math.floor(h) + 'px';
                     ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
                     //scope.resetDrawing()
                     //ctx.scale(scope.scale,scope.scale);
                     $scope.resetDrawing()
                     canvas.style.pointerEvents = 'auto|none';
                 };

                 $scope.clearPageAnnotation = function() {
                     for (var i in points) {
                         if (points[i].page == $scope.pageNumber) {
                             points.splice(i, 1);
                             //break;
                             $scope.clearPageAnnotation()
                         }
                     }
                     $scope.resetDrawing();
                 };

                 $scope.updateNewDrawing = function(pts) {
                     points = []
                     points = pts
                     $scope.resetDrawing()
                 }
                 $scope.setTool = function(toolName, data) {

                     for (var i in $scope.tools) {
                         if ($scope.tools[i] != data) {
                             $scope.tools[i].expanded = false;
                         }
                     }
                     data.expanded = !data.expanded;

                     if (data.expanded) {
                         $scope.tool = toolName
                     } else {
                         $scope.tool = ''
                     }
                 }
                 $scope.resetDrawing = function() {
                     ctx.clearRect(0, 0, $scope.windowWidth, $scope.windowHeight);
                     // Resize original canvas
                     //canvas.width = window.innerWidth;
                     //canvas.height = window.innerHeight;
                     let imgs = [];
                     let imgIndex = 0;
                     //Load previously Saved Annotation
                     for (var i in points) {
                         ctx.beginPath()
                         if (points[i].page == $scope.pageNumber) {
                             //ctx.lineWidth = 2;
                             ctx.lineJoin = ctx.lineCap = 'round';
                             if (points[i].tool_name == 'Pencil') {
                                 ctx.lineWidth = points[i].thickness; //scope.lineThickness;
                                 ctx.strokeStyle = '#FFFFFF'
                                 ctx.moveTo(points[i].draw_points[0].x, points[i].draw_points[0].y);
                                 for (var j = 1; j < points[i].draw_points.length; j++) {
                                     ctx.lineTo(points[i].draw_points[j].x, points[i].draw_points[j].y);
                                 }
                                 ctx.stroke();
                             } else if (points[i].tool_name == 'Marker') {
                                 ctx.lineWidth = 15; //points[i].thickness;
                                 ctx.strokeStyle = '#000000'
                                 if (points[i].draw_points != undefined) {
                                     ctx.moveTo(points[i].draw_points[0].x, points[i].draw_points[0].y);
                                     for (var j = 1; j < points[i].draw_points.length; j++) {
                                         ctx.lineTo(points[i].draw_points[j].x, points[i].draw_points[j].y);
                                     }
                                     ctx.stroke();
                                 }

                             }
                         }
                     }
                 };
                 canvas.onmouseover = function(event) {
                     if (event.offsetX !== undefined) {
                         currentX = event.offsetX;
                         currentY = event.offsetY;
                     } else {
                         currentX = event.layerX - event.currentTarget.offsetLeft;
                         currentY = event.layerY - event.currentTarget.offsetTop;
                     }

                     for (var i in points) {
                         if (points[i].page == $scope.pageNumber && points[i].tool_name == 'Notes') {
                             if (currentX < points[i].right && currentX > points[i].left && currentY > points[i].top && currentY < points[i].bottom) {
                                 //alert ('Your Notes : ' + points[i].notes);
                                 //isNotesOpen = true
                             }
                         }
                     }
                 }
                 canvas.onmouseout = function(event) {
                     if (event.offsetX !== undefined) {
                         currentX = event.offsetX;
                         currentY = event.offsetY;
                     } else {
                         currentX = event.layerX - event.currentTarget.offsetLeft;
                         currentY = event.layerY - event.currentTarget.offsetTop;
                     }

                     for (var i in points) {
                         if (points[i].page == $scope.pageNumber && points[i].tool_name == 'Notes') {
                             if (currentX < points[i].right && currentX > points[i].left && currentY > points[i].top && currentY < points[i].bottom) {
                                 //alert ('Your Notes : ' + points[i].notes);
                                 //isNotesOpen = true
                             }
                         }
                     }
                 }
                 canvas.addEventListener('touchstart', onTouchStart, false);
                 canvas.addEventListener('touchmove', onTouchMove, false);
                 canvas.addEventListener('touchend', onTouchEnd, false);

                 canvas.addEventListener('mousedown', onMouseStart, false);
                 canvas.addEventListener('mousemove', onMouseMove, false);
                 canvas.addEventListener('mouseup', onMouseEnd, false);

                 $window.addEventListener('load', resize, false);
                 $window.addEventListener('resize', resize, false);

                 function resize() {

                     /* // Our canvas must cover full height of screen
                      // regardless of the resolution
                      var height = window.innerHeight;
                      // So we need to calculate the proper scaled width
                      // that should work well with every resolution
                      var ratio = canvas.width / canvas.height;
                      var width = height * ratio;

                      canvas.style.width = width + 'px';
                      canvas.style.height = height + 'px';*/


                 }
                 // Get the position of a touch relative to the canvas
                 function getTouchPos(canvasDom, touchEvent) {
                     var rect = canvasDom.getBoundingClientRect();
                     return {
                         x: touchEvent.touches[0].clientX - rect.left,
                         y: touchEvent.touches[0].clientY - rect.top
                     };
                 }
                 // Get the position of the mouse relative to the canvas
                 function getMousePos(canvasDom, mouseEvent) {
                     var rect = canvasDom.getBoundingClientRect();
                     return {
                         x: mouseEvent.clientX - rect.left,
                         y: mouseEvent.clientY - rect.top
                     };
                 }

                 document.body.addEventListener("touchstart", function(e) {
                     if (e.target == canvas && !drawing) {
                         e.preventDefault();
                     }
                 }, false);
                 document.body.addEventListener("touchend", function(e) {
                     if (e.target == canvas && drawing) {
                         e.preventDefault();
                     }
                 }, false);
                 document.body.addEventListener("touchmove", function(e) {
                     if (e.target == canvas && drawing) {
                         e.preventDefault();
                     }
                 }, false);

                 function onTouchStart(event) {
                     mousePos = getTouchPos(canvas, event);
                     var touch = event.touches[0];
                     var mouseEvent = new MouseEvent("mousedown", {
                         clientX: touch.clientX,
                         clientY: touch.clientY
                     });
                     canvas.dispatchEvent(mouseEvent);
                 }

                 function onTouchMove(event) {
                     var touch = event.touches[0];
                     var mouseEvent = new MouseEvent("mousemove", {
                         clientX: touch.clientX,
                         clientY: touch.clientY
                     });
                     canvas.dispatchEvent(mouseEvent);
                 }

                 function onTouchEnd(event) {
                     var mouseEvent = new MouseEvent("mouseup", {});
                     canvas.dispatchEvent(mouseEvent);
                 }

                 function onMouseStart(event) {
                     lastX = lastY = ''
                     lastPos = getMousePos(canvas, event);
                     if (event.offsetX !== undefined) {
                         lastX = event.offsetX;
                         lastY = event.offsetY;
                     } else {
                         lastX = lastPos.x; //event.layerX - event.currentTarget.offsetLeft;
                         lastY = lastPos.y; //event.layerY - event.currentTarget.offsetTop;
                     }

                     // begins new line
                     ctx.beginPath();
                     fhPoints = []
                     drawing = true;
                     let isNotesOpen = false

                     if ($scope.tool == 'Pencil') {
                         ctx.lineWidth = $scope.lineThickness;
                         ctx.strokeStyle = '#FFFFFF' //$scope.selected; //
                         ctx.fillStyle = '#FFFFFF' //$scope.selected; //'#FFFFFF';
                         ctx.moveTo(lastX, lastY);
                         fhPoints.push({
                             x: lastX,
                             y: lastY
                         });
                         canvas.style.cursor = "url('/pdf/ic_create_cursor.png'), auto";

                     } else if ($scope.tool == 'Marker') {
                         ctx.lineWidth = 15; //scope.lineThickness;
                         ctx.strokeStyle = '#000000'
                             //ctx.fillStyle = 'rgba(255, 255, 0, 0.3)';
                         ctx.moveTo(lastX, lastY);
                         fhPoints.push({
                             x: lastX,
                             y: lastY
                         });
                         canvas.style.cursor = "url('/pdf/ic_eraser_cursor.png'), auto";
                     }


                 }

                 function onMouseMove(event) {
                     if (drawing) {
                         // get current mouse position
                         currentPos = getMousePos(canvas, event);
                         if (event.offsetX !== undefined) {
                             currentX = event.offsetX;
                             currentY = event.offsetY;
                         } else {
                             currentX = currentPos.x; //event.layerX - event.currentTarget.offsetLeft;
                             currentY = currentPos.y; //event.layerY - event.currentTarget.offsetTop;
                         }

                         if ($scope.tool == 'Pencil') {
                             ctx.lineTo(currentX, currentY);
                             fhPoints.push({
                                 x: currentX,
                                 y: currentY
                             });
                             ctx.stroke();
                         } else if ($scope.tool == 'Marker') {
                             ctx.lineTo(currentX, currentY);
                             fhPoints.push({
                                 x: currentX,
                                 y: currentY
                             });
                             ctx.stroke();
                         }

                     }
                 }


                 function onMouseEnd(event) {

                     let valueObj = {}
                     drawing = false;
                     if (event.offsetX !== undefined) {
                         currentX = event.offsetX;
                         currentY = event.offsetY;
                     } else {
                         currentX = event.layerX - event.currentTarget.offsetLeft;
                         currentY = event.layerY - event.currentTarget.offsetTop;
                     }
                     if ($scope.tool == 'Pencil') {

                         valueObj = {
                             page: $scope.pageNumber,
                             tool_name: $scope.tool,
                             draw_points: fhPoints,
                             thickness: $scope.lineThickness,
                             user_id: Meteor.userId()

                         }
                         points.push(valueObj)
                         canvas.style.cursor = "default";
                     } else if ($scope.tool == 'Marker') {

                         valueObj = {
                             page: $scope.pageNumber,
                             tool_name: $scope.tool,
                             draw_points: fhPoints,
                             thickness: 15,
                             user_id: Meteor.userId()
                         }
                         points.push(valueObj)
                         $scope.resetDrawing()
                         canvas.style.cursor = "default";
                     }


                 }
                 // Get a regular interval for drawing to the screen
                 window.requestAnimFrame = (function(callback) {
                     return window.requestAnimationFrame ||
                         window.webkitRequestAnimationFrame ||
                         window.mozRequestAnimationFrame ||
                         window.oRequestAnimationFrame ||
                         window.msRequestAnimaitonFrame ||
                         function(callback) {
                             window.setTimeout(callback, 1000 / 60);
                         };
                 })();

             })
         }, 0);
         $scope.tools = [{
             tool: 'Pencil',
             expanded: true,
             icon: '/pdf/ic_create.png'
         }, {
             tool: 'Marker',
             expanded: false,
             icon: '/pdf/ic_eraser.png'
         }]
         $scope.tool = 'Pencil'
         $scope.pageNumber = 1
         $scope.scale = 1.0
         $scope.lineThickness = 2
         $scope.totalPageNumber = 1
         $scope.setTools = function(toolName, data) {

             for (var i in $scope.tools) {
                 if ($scope.tools[i] != data) {
                     $scope.tools[i].expanded = false;
                 }
             }
             data.expanded = !data.expanded;

             if (data.expanded) {
                 $scope.tool = toolName
             } else {
                 $scope.tool = ''
             }
         }
         $scope.uploadDrawing = function(index) {
             let today = new Date()
             var day = today.getDay()
             var currentDay = new Date(today.getFullYear(), today.getMonth(), today.getDate())
             document.getElementById('canvas_' + $scope.$parent.indexToShow).style.overflow = 'visible'; //might need to do this to grandparent nodes as well, possibly.
             html2canvas([document.getElementById('canvas_' + $scope.$parent.indexToShow)], {
                 onrendered: function(canvas) {
                     document.getElementById('canvas_' + $scope.$parent.indexToShow).style.overflow = 'visible';
                     var dataUrl = canvas.toDataURL();
                     let fileObj = Upload.dataUrltoBlob(dataUrl)
                     uploadService.uploadCheckService(fileObj, $scope.serverUrl, $scope.userPath, function(result) {
                         if (result.url) {
                             self.questions[index].answerImg = result.url;
                             //self.questions[index].answer=result.url;
                         }

                     })

                 }
             });
         }
     }
 }
 export default AttendExam



// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/activity/attendExam.js